import { MOBILE_BOT_RAIL_STORAGE_KEY } from "@rakazo/core";

let preference: boolean | undefined;
const listeners = new Set<() => void>();
export function getMobileBotRail(): boolean {
  if (preference !== undefined) return preference;
  try {
    return localStorage.getItem(MOBILE_BOT_RAIL_STORAGE_KEY) === "true";
  } catch {
    return false;
  }
}
export function setMobileBotRail(enabled: boolean): void {
  preference = enabled;
  try {
    localStorage.setItem(MOBILE_BOT_RAIL_STORAGE_KEY, String(enabled));
  } catch {
    /* Keep the current choice without storage. / Зберігаємо вибір у пам'яті. */
  }
  for (const listener of listeners) listener();
}
export function subscribeMobileBotRail(listener: () => void) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
